<app-hourglass *ngIf="spinner"></app-hourglass>
<mat-card *ngIf="ready && !failed" class="scheduler" id="scheduler">
    <div class="current-OC" id="onCall.name">
        <label>Current On Call:</label>
        <div *ngFor="let onCall of onCalls">
            {{ onCall.name }}
        </div>
    </div>
    <div class="whole-cal">
        <div class="top-row">
            <h6 class="current-month">
                <mat-icon (click)="changeMonth(-1)" *ngIf="!spinner" id="arrow_left">arrow_left</mat-icon>
                {{ currentMonthString }}
                <mat-icon (click)="changeMonth(1)" *ngIf="!spinner" id="arrow_right">arrow_right</mat-icon>
            </h6>
            <div>{{currentMonth}}/{{ currentDayOfMonth }}/{{ currentYear }}</div>
        </div>
        <div class="calendar" id="calendar">
            <div class="templateWeek" id="templateWeek">
                <div class="day-template">
                    S
                </div>
                <div class="day-template">
                    M
                </div>
                <div class="day-template">
                    T
                </div>
                <div class="day-template">
                    W
                </div>
                <div class="day-template">
                    T
                </div>
                <div class="day-template">
                    F
                </div>
                <div class="day-template">
                    S
                </div>
            </div>
            <div (click)="openWeeklySchedule(week)" *ngFor="let week of weeks; let i = index" class="week" id="week">
                <div (click)="changeDay(day);" *ngFor="let day of week; let j = index" [class]="'day ' + day.selected" id="daySelected-{{i}}-{{j}}">
                    {{ day.date }}
                    <div class="event-container" id="event-container-{{i}}-{{j}}">
                        <span *ngFor="let event of day.coverage"
                              [class]="'event ' + event.color"
                              [style.height.%]="(event.duration / 24) * 100">
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <mat-card class="legend">
        <label>Legend:</label>
        <div *ngFor="let recipient of recipients" id="recipientName">
            <br/>
            {{ recipient.name }}
            <div [class]="'participant ' + recipient.color "></div>
        </div>
    </mat-card>
    <app-timezone (selectedEvent)="handleTimezoneChange($event)" id="selectedEventType" [defaultId]="timezone ? timezone : intlForHTML.DateTimeFormat().resolvedOptions().timeZone"></app-timezone>
</mat-card>
<mat-card *ngIf="failed" id="failedSchedule">
    Could not find schedule
</mat-card>
